// actions
import * as Common from './Common';
import * as Filters from './Filters';
import * as MainGrid from "./MainGrid";
import * as Submission from "./Submission";
import * as Files from "./Files";
import * as ActionToolbar from "./ActionToolbar";
import * as App from './App';
import * as Landing from "./Landing";
import * as CreateSubmission from "./CreateSubmission";
import * as Dashboard from "./Dashboard";
import * as Preferences from "./Preferences";
import * as Help from "./Help";
import * as SubmissionStatusActions from "./SubmissionStatusActions";
import * as Template from "./Template"
import * as SubmissionPopup from "./SubmissionPopup";
import * as  SelectSuppliers from "./SelectSuppliers";
import * as Quotes from "./Quotes"
import * as UploadDialog from "./UploadDialog";
import * as SourceFiles from "./SourceFiles";
import * as TestActions from "./TestActions";
import * as PromoteDemote from "./PromoteDemote/PromoteDemoteActions";
import * as Impersonate from "./Impersonate";
import * as MultiClaimUnclaim from "./MultiClaimUnclaim";
import supplierActions from "./SupplierView";
import reopenActions from "./Reopen";
import * as Announcement from "./Announcement";
import * as GradingAndScoring from "./GradingAndScoring";
import * as PingingRequest from './PingingRequest';
import * as Widgets from './Widgets/Widgets';
import * as SubmissionMassActions from "./SubmissionMassActions";


let actions = {
  ...ActionToolbar,
  ...App,
  ...Announcement,
  ...Common,
  ...CreateSubmission,
  ...Dashboard,
  ...Files,
  ...Filters,
  ...Help,
  ...Landing,
  ...MainGrid,
  ...MultiClaimUnclaim,
  ...PingingRequest,
  ...Preferences,
  ...Quotes,
  ...SelectSuppliers,
  ...SourceFiles,
  ...Submission,
  ...SubmissionPopup,
  ...SubmissionStatusActions,
  ...Template,
  ...TestActions,
  ...UploadDialog,
  ...PromoteDemote,
  ...Impersonate,
  ...reopenActions,
  ...supplierActions,
  ...GradingAndScoring,
  ...Widgets,
  ...SubmissionMassActions
};

export default actions;
